export const createUserSaveRequest = userEntry => {
  const saveRequest = {
    email: userEntry.email,
    endDate: userEntry.endDate,
    firstName: userEntry.firstName,
    languageCode: userEntry.languageCode,
    lastName: userEntry.lastName,
    role: userEntry.role,
    startDate: userEntry.startDate,
    stores: userEntry.stores,
    username: userEntry.username,
    phoneNumber: userEntry.phoneNumber,
    password: userEntry.password,
  }

  return JSON.stringify(saveRequest)
}

export const createUserUpdateRequest = userEntry => {
  const updateRequest = {
    email: userEntry.email,
    endDate: userEntry.endDate,
    firstName: userEntry.firstName,
    languageCode: userEntry.languageCode,
    lastName: userEntry.lastName,
    role: userEntry.role,
    startDate: userEntry.startDate,
    username: userEntry.username,
    phoneNumber: userEntry.phoneNumber,
  }

  return JSON.stringify(updateRequest)
}

export const createUpdateMeRequest = userEntry => {
  const updateRequest = {
    email: userEntry.email,
    firstName: userEntry.firstName,
    lastName: userEntry.lastName,
    username: userEntry.username,
    phoneNumber: userEntry.phoneNumber,
  }

  return JSON.stringify(updateRequest)
}
export const createUserStoresUpdateRequest = userEntry => {
  const updateRequest = {
    stores: userEntry.stores,
  }

  return JSON.stringify(updateRequest)
}

export const createUserAuthoritiesUpdateRequest = ({
  additionalAuthorities,
  restrictedAuthorities,
}) =>
  JSON.stringify({
    authorities: additionalAuthorities,
    restrictedAuthorities,
  })
